import { render } from "./SubmitDraftSection.vue?vue&type=template&id=3b69207b"
import script from "./SubmitDraftSection.vue?vue&type=script&lang=js"
export * from "./SubmitDraftSection.vue?vue&type=script&lang=js"

import "./SubmitDraftSection.vue?vue&type=style&index=0&id=3b69207b&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__